import { useEffect, useState } from 'react';
import NediRowButton from '../nedi/NediRowButton';
import '../nedi/nediAnatomy.css';
import './Buttons.css';
import './CityReplayPanel.css';

const MIN_QUERY = 2;

function CityReplayPanel({
  onCitySearch,
  onCitySelect,
  selectedCity = null,
}) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!onCitySearch || query.length < MIN_QUERY) {
      setResults([]);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);

    const timer = setTimeout(() => {
      onCitySearch(query)
        .then((items) => {
          if (!cancelled) setResults(Array.isArray(items) ? items : []);
        })
        .catch(() => {
          if (!cancelled) setResults([]);
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }, 250);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [onCitySearch, query]);

  return (
    <div className="av-city-replay" data-nedi-panel="city-replay">
      <p className="av-city-replay-lead">
        Busque uma cidade e assista sua história se desenrolar no mapa — check-ins,
        rotas, diário e mais, em ordem cronológica.
      </p>

      <label className="av-city-replay-label" htmlFor="av-city-replay-search">
        Cidade
      </label>
      <input
        id="av-city-replay-search"
        type="search"
        className="av-city-replay-input"
        placeholder="Nome da cidade…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        autoComplete="off"
      />

      {query.length >= MIN_QUERY && !loading && results.length === 0 && (
        <p className="av-city-replay-hint">Nenhuma cidade encontrada.</p>
      )}
      {loading && <p className="av-city-replay-hint">Buscando…</p>}

      {results.length > 0 && (
        <ul className="nedi-row-stack av-city-replay-results" role="list">
          {results.map((city, index) => (
            <li key={`${city.city}-${index}`}>
              <NediRowButton
                className="av-city-replay-result"
                title={city.city}
                subtitle={
                  [
                    [city.state, city.country].filter(Boolean).join(', ') || city.country || '',
                    city.count ? `${city.count} locais` : '',
                  ]
                    .filter(Boolean)
                    .join(' · ')
                }
                onClick={() => {
                  onCitySelect?.(city);
                  setQuery('');
                  setResults([]);
                }}
              />
            </li>
          ))}
        </ul>
      )}

      {selectedCity && (
        <p className="av-city-replay-active">
          Replay ativo: <strong>{selectedCity}</strong>. Os controles aparecem sobre o mapa no workspace Atlas.
        </p>
      )}

      <p className="av-city-replay-tip">
        Dica: amplie o período na barra superior se a cidade parecer vazia. Para guardar
        memórias sem exportar vídeo, use <strong>Imprimir período</strong> ou <strong>Memory Book</strong>.
      </p>
    </div>
  );
}

export default CityReplayPanel;
